module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gc-Hb-Ic.cbd2ba08.png";